var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaladsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 6.7C9.4 6.6 9.4 6.5 9.4 6.3L7.7 0.7C7.6 0.3 7.2 0 6.8 0C6.7 0 6.6 0 6.5 0C5.9 0.2 5.6 0.8 5.8 1.3L7.3 6.6H5.5L3.4 0.8C3.2 0.4 2.9 0.1 2.5 0.1C2.4 0.1 2.2 0.1 2.1 0.2C1.6 0.5 1.4 1.2 1.6 1.8L3.4 6.7H0L0.2 7.8C0.6 11 2.8 13.7 5.8 15.1C5.7 15.3 5.6 15.5 5.6 15.7V16.4C5.6 17.1 6.2 17.7 6.9 17.7H14.3C15 17.7 15.6 17.1 15.6 16.4V15.7C15.6 15.5 15.6 15.3 15.5 15.1C18.5 13.7 20.6 11 21.1 7.8L21.2 6.7H9.4ZM10.6 14.2C6.7 14.2 3.4 11.9 2.4 8.7H18.8C17.8 11.9 14.5 14.2 10.6 14.2Z",
    fill: "#EB9F1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaladsActive);
export default __webpack_public_path__ + "static/media/SaladsActive.651d7d47616e40d0361c8412d0ca3d9b.svg";
export { ForwardRef as ReactComponent };